import { Pipe, PipeTransform } from '@angular/core';
import { ITicketTile } from '../../components/data-display/ticket-tile/ticket-tile.component';
import { FormGroup } from '@angular/forms';
import { ITicketTileForm } from '../../entities/sortiment-form.entity';
import {
  decimalsToCents,
  ERelationType,
  IDirectTicket,
  ITicket,
  ShopTicket,
  TariffProductDefinition,
  ViaName,
} from '@web/dtos';
import { FilterTextsPipe } from '../filterTexts/filterTexts.pipe';

// @TODO maybe actually provide default translations

export const DEFAULT_TICKET_TILE: ITicketTile = {
  name: 'default-ticket',
  detailsTitle: [],
  details: [],
  afterPriceText: '',
  via: ['VIA1' as ViaName, 'VIA2' as ViaName, 'VIA3' as ViaName],
  description: [],
  viaBanner: 'list',
  title: [],
};

@Pipe({
  name: 'toTicketTile',
})
export class ToTicketTilePipe implements PipeTransform {
  private readonly filterTexts: FilterTextsPipe = new FilterTextsPipe();

  transform(
    ticket: Partial<ITicket> | ShopTicket | FormGroup<ITicketTileForm>['value'],
    name: string
  ): ITicketTile {
    return (ticket as FormGroup<ITicketTileForm>['value'])?.title
      ? this.transformFromForm(
          name,
          ticket as FormGroup<ITicketTileForm>['value']
        )
      : this.transformFromCombinedTicket(name, ticket as ShopTicket);
  }

  private transformFromForm(
    name: string,
    ticket: FormGroup<ITicketTileForm>['value']
  ): ITicketTile {
    return {
      name,
      detailsTitle: ticket.detailsTitle ?? DEFAULT_TICKET_TILE.detailsTitle,
      image: undefined,
      details:
        ticket?.details?.map(detail => {
          return {
            link: detail.link,
            type: detail.type ?? 'text',
            icon: detail.icon,
            text: detail.texts ?? [],
          };
        }) ?? [],
      afterPriceText: DEFAULT_TICKET_TILE.afterPriceText,
      via: DEFAULT_TICKET_TILE.via, //@TODO use proper via if applicable
      description: ticket.description ?? DEFAULT_TICKET_TILE.description,
      viaBanner: 'list',
      title: ticket.title ?? DEFAULT_TICKET_TILE.title,
    };
  }

  private transformFromCombinedTicket(
    name: string,
    shopTicket: ShopTicket
  ): ITicketTile {
    const ticket: ITicket | undefined = shopTicket?.ticketData;
    const defaultDefinition: TariffProductDefinition | undefined = (
      shopTicket as IDirectTicket
    )?.productDefinitions?.[0];
    return {
      name,
      detailsTitle: this.filterTexts.transform(
        ticket?.texts ?? DEFAULT_TICKET_TILE.detailsTitle,
        ERelationType.detailsTitle
      ),
      image: ticket?.accessibleImage,
      details:
        ticket?.details?.map(detail => {
          return {
            link: detail.link,
            type: detail.type,
            icon: detail.icon,
            text: detail.texts ?? [],
          };
        }) ?? [],
      price:
        ticket?.displayPrice &&
        defaultDefinition?.price?.priceIncludingVat !== undefined
          ? decimalsToCents(defaultDefinition.price.priceIncludingVat)
          : undefined,
      afterPriceText: DEFAULT_TICKET_TILE.afterPriceText,
      via: (defaultDefinition?.via?.split(',') as ViaName[]) || [],
      description: this.filterTexts.transform(
        ticket?.texts ?? DEFAULT_TICKET_TILE.description,
        ERelationType.description
      ),
      viaBanner: 'list',
      title: this.filterTexts.transform(
        ticket?.texts ?? DEFAULT_TICKET_TILE.detailsTitle,
        ERelationType.title
      ),
    };
  }
}
